import {Button, Modal} from "antd";
import React from "react";

const CourierTypeModal = ({modalState, mileInformations}) => {
    const [isModalOpen, setIsModalOpen] = modalState;

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const renderMileInfo = mileInfo => {
        if (Array.isArray(mileInfo.type) && Array.isArray(mileInfo.number)) {
            return mileInfo.type.map((type, index) => (
                <li
                    key={index}
                    style={{margin: "10px", gap: "10px", display: "flex", flexDirection: "column"}}
                >
                    <h3>{mileInfo.transferCenterName}</h3>
                    <div style={{display: "flex", gap: "15px", alignItems: "center"}}>
                        <b>
                            {type === "car"
                                ? `Araç Kurye ${mileInfo.number} : `
                                : `Motor Kurye ${mileInfo.number}: `}
                        </b>
                        <span>{mileInfo.packageCount} Paket</span>
                    </div>
                </li>
            ));
        }

        return (
            <li style={{margin: "10px", gap: "10px", display: "flex", flexDirection: "column"}}>
                <h3>{mileInfo.transferCenterName}</h3>
                <div style={{display: "flex", gap: "15px", alignItems: "center"}}>
                    <b>
                        {mileInfo.type === "car"
                            ? `Araç Kurye ${mileInfo.number} : `
                            : `Motor Kurye ${mileInfo.number}: `}
                    </b>
                    <span>{mileInfo.packageCount} Paket</span>
                </div>
            </li>
        );
    };

    return (
        <Modal
            title="Kuryeler"
            visible={isModalOpen}
            onCancel={handleCancel}
            footer={[
                <Button key="ok" type="primary" onClick={handleOk}>
                    Tamam
                </Button>
            ]}
        >
            <ul>
                {mileInformations?.map((mileInfo, index) => (
                    <div key={index}>{renderMileInfo(mileInfo)}</div>
                ))}
            </ul>
        </Modal>
    );
};

export default CourierTypeModal;
